import { useEffect } from 'react'

const APP_NAME = 'Steppingblocks Graduate Insights'

/**
 * Sets the browser tab title for the current page.
 * @param {string} pageTitle - The name of the current page.
 */
const usePageTitle = pageTitle => {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME

    return () => {
      document.title = APP_NAME
    }
  }, [pageTitle])
}

export default usePageTitle
